<template>
  <div class="RnDownload">
    <h1 v-if="RnDate">{{ `魅爱TV${RnDate.ldy_rn.name}` }}</h1>
    <div class="line"></div>
    <div class="step1">
      <img :src="RnDate.ldy_rn.img" alt="" />
      <div class="download-btn" @click="downloadBtn">立即下载</div>
    </div>
    <div class="down-icon"><img src="./images/jt_red@2x.png" alt="" /></div>
    <p class="tip">此应用即为 App Store 的魅爱TV,如假包换,请放心下载</p>
    <p class="footer-tip" v-if="!ios16">
      若打开后不显示魅爱TV，则需回到本页面重新下载App
    </p>
    <div class="line2" v-if="ios16"></div>
    <div v-if="ios16">
      <div class="step2"><img src="./images/tsts_bg@2x.png" alt="" /></div>
      <div class="copy-box">
        <div>
          <img src="./images/iphone@2x.png" alt="" />
          <img src="./images/ipad@2x.png" alt="" />
          <p class="">iPhone和iPad App</p>
        </div>
        <p class="key-btn" @click="doCopy">复制密钥</p>
      </div>
      <p class="footer-tip">
        若打开后不显示魅爱TV，则需回到本页面复制密钥重新打开App，并允许读取剪贴板
      </p>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    RnDate: {
      type: Object,
    },
    imgUrl: {
      type: String,
    },
    ios16: {
      type: Boolean,
    },
  },
  data() {
    return {
      host: location.origin + location.pathname.replace("/config.php", ""),
    };
  },
  created() {
    console.log(this.RnDate, "rn数据");
  },

  methods: {
    downloadBtn() {
      this.$emit("downloadRn");
    },
    // 拼接图片域名
    imageDomain(name) {
      return this.host + name;
    },
    doCopy() {
      //   let code = this.getUrlParam('code')
      let _text = this.RnDate.download_secret;
      this.$copyText(_text)
        .then(() => {
          this.$toast("复制成功");
        })
        .catch((er) => {
          this.$toast.fail("复制失败");
          console.err(er);
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.RnDownload {
  padding: 0 16px;
  p {
    margin: 10px 0;
  }
  h1 {
    text-align: center;
    margin-top: 15px;
    color: rgb(7, 7, 7);
    font-family: PingFang SC;
    font-weight: 700;
    font-size: 18px;
  }
  .line {
    width: 330px;
    border: 0.1px solid rgb(247, 242, 242);
    margin: 0 auto;
  }
  .line2 {
    width: 100%;
    border: 0.1px solid rgb(247, 242, 242);
    margin: 15px auto;
    font-weight: normal;
  }
  .tip {
    color: rgb(233, 77, 66);
    font-size: 14px;
    font-weight: 700;
  }
  .step1 {
    width: 304px;
    height: 122px;
    margin: 0 auto;
    position: relative;
    img {
      height: 100%;
    }
  }
  .download-btn {
    width: 90px;
    height: 29px;
    color: rgb(255, 255, 255);
    background-color: rgb(0, 132, 251);
    font-size: 15px;
    border-radius: 32px;
    text-align: center;
    line-height: 29px;
    position: absolute;
    bottom: 12px;
    left: 120px;
  }
}
.step2 {
  width: 298px;
  height: 155px;
  margin: 0 auto;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}
.down-icon {
  width: 24px;
  height: 27px;
  margin-left: 70px;
  img {
    width: 100%;
    height: 100%;
  }
}
.copy-box {
  display: flex;
  margin: 0 auto;
  background-color: red($color: #000000);
  width: 300px;
  justify-content: space-between;
  align-items: center;
  div {
    display: flex;
    justify-content: center;
    align-items: center;
    p {
      color: rgb(141, 143, 150);
      font-size: 10px;
      margin-left: 15px;
    }
    img {
      width: 11px;
      height: 13px;
      padding-left: 5px;
    }
  }
  .key-btn {
    width: 83px;
    height: 29px;
    background: linear-gradient(
      270deg,
      rgba(237, 74, 64, 1) 0%,
      rgba(242, 142, 62, 1) 100%
    );
    border-radius: 20px;
    color: #eaeaea;
    font-size: 15px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.footer-tip {
  color: rgb(0, 0, 0);
  font-size: 14px;
  font-weight: 700;
}
</style>
